import AddItemForm from "../../../../components/AddFormItem";


const ProjectAdd = () => {
    return (
        <div>
            <h2>Add</h2>
            <AddItemForm endpoint={"projects"}/>
        </div>
    );
};

export default ProjectAdd